import { Component, Input, OnInit } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { CustomerObjectServiceHistoryDto } from "../../../models/customerObject/customer-object-service-history-dto";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";

@Component({
	selector: 'customer-object-service-history-dialog',
	templateUrl: './customer-object-service-history-dialog.component.html',
	styleUrls: [
		'./customer-object-service-history-dialog.component.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class CustomerObjectServiceHistoryDialogComponent implements OnInit {

	@Input() requestId: number;
	@Input() plannedMaintenanceId: number;

	item: CustomerObjectServiceHistoryDto = null;
	loading: boolean = false;

	constructor(
		public dialog: DialogRef,
		private customerObjectsService: CustomerObjectsService
	) { }

	ngOnInit(): void {
		this.loading = true;
		this.customerObjectsService.getServiceHistory(this.requestId, this.plannedMaintenanceId).subscribe(resp => {
			this.item = resp;
			this.loading = false;
		}, () => this.loading = false);
	}
}
